import React, { useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon, ArrowRightIcon, ArrowDownIcon, CalendarIcon, MapPinIcon, BellIcon, MessageSquareIcon, RecycleIcon, CheckCircle2Icon } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useLanguage } from '../components/LanguageContext';
import { CollectHero } from '../components/collect/CollectHero';
import { CollectChallenge } from '../components/collect/CollectChallenge';
import { CollectJourneys } from '../components/collect/CollectJourneys';
import { CollectProof } from '../components/collect/CollectProof';
import { CollectFinalCTA } from '../components/collect/CollectFinalCTA';
import { trackEvent as track } from '../utils/analytics';
const reveal = {
  initial: {
    opacity: 0,
    y: 30
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-80px'
  },
  transition: {
    duration: 0.7
  }
};
const COMPARISON_ROWS = [{
  traditional: {
    fr: 'Calendrier papier',
    en: 'Paper Calendar'
  },
  bciti: {
    fr: 'Adresse vérifiée',
    en: 'Verified Address'
  }
}, {
  traditional: {
    fr: 'PDF générique',
    en: 'Generic PDF'
  },
  bciti: {
    fr: 'Calendrier personnalisé',
    en: 'Personalized Calendar'
  }
}, {
  traditional: {
    fr: 'Qui est responsable\u00A0?',
    en: 'Who is responsible?'
  },
  bciti: {
    fr: 'La bonne réponse',
    en: 'The right answer'
  }
}, {
  traditional: {
    fr: 'Appeler le service à la clientèle',
    en: 'Call the service desk'
  },
  bciti: {
    fr: 'ATNA répond instantanément',
    en: 'ATNA responds instantly'
  }
}, {
  traditional: {
    fr: 'Confusion au tri',
    en: 'Sorting confusion'
  },
  bciti: {
    fr: 'Réponses de tri instantanées',
    en: 'Instant sorting answers'
  }
}, {
  traditional: {
    fr: 'Aucune visibilité',
    en: 'No visibility'
  },
  bciti: {
    fr: 'Analytique par secteur',
    en: 'Area-level analytics'
  }
}];
const WORKFLOW = [{
  fr: 'Adresse vérifiée',
  en: 'Verified Address'
}, {
  fr: 'Calendrier personnalisé',
  en: 'Personalized Calendar'
}, {
  fr: 'Usage hebdomadaire',
  en: 'Weekly Usage'
}, {
  fr: 'Foyer engagé',
  en: 'Engaged Household'
}, {
  fr: 'Socle des services futurs',
  en: 'Foundation For Future Services'
}];
export function Collect() {
  const {
    lang
  } = useLanguage();
  const t = (fr: string, en: string) => lang === 'FR' ? fr : en;
  useEffect(() => {
    track('Page Viewed', {
      page: 'Collect'
    });
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-8468" data-mp="248lo7aur6c1v">
      <Header data-id="element-8469" data-mp="1zak9f24d0yw7" />

      <main className="pt-[120px]" data-id="element-8470" data-mp="1zasj6l56ro36">
        {/* SECTION 1: HERO */}
        <section className="pt-16 pb-24 px-6" data-id="element-8471" data-mp="1zcn07odc6w1z">
          <CollectHero data-id="element-8472" data-mp="suq9g37rg5b6" />
        </section>

        {/* SECTION 1b: THE CHALLENGE */}
        <section className="py-28 lg:py-32 px-6 border-t border-[#E4E6EC] bg-[#FAFAFB]" data-id="element-8473" data-mp="nuvk443mvns8">
          <CollectChallenge data-id="element-8474" data-mp="2zj0hbucbln6i" />
        </section>

        {/* SECTION 2: AN EXPERIENCE THAT ADAPTS TO CONTEXT */}
        <section className="py-28 lg:py-32 px-6 border-t border-[#E4E6EC]" data-id="element-8475" data-mp="34ha8zuyu65nd">
          <CollectJourneys data-id="element-8476" data-mp="39gwq4fhsc61g" />
        </section>

        {/* SECTION 4: PROOF */}
        <section id="proof" className="py-28 lg:py-32 px-6 border-t border-[#E4E6EC] bg-[#FAFAFB] scroll-mt-24" data-id="element-8477" data-mp="39etqd3qtyyjj">
          <CollectProof data-id="element-8478" data-mp="3j6q1bfe0mj56" />
        </section>

        {/* SECTION 5: FINAL CTA */}
        <section className="border-t border-[#E4E6EC] bg-white" data-id="element-8479" data-mp="3j8smnm483o3k">
          <CollectFinalCTA data-id="element-8480" data-mp="3n705qnm5t1hx" />
        </section>

      </main>

      <Footer data-id="element-8481" data-mp="3s7nv74uqpaa1" />
    </div>;
}